import clsx from "clsx";
import { PrismicNextImage } from "@prismicio/next";

export default function BackgroundImage({
  slice,
  className = "",
  horizontalGradient = false,
  imageClassName = "",
  teamMember,
}) {
  const desktopImage = slice?.background_image;
  const tabletImage = slice?.background_image?.tablet;
  const mobileImage = slice?.background_image?.mobile;

  return (
    <div
      className={`absolute z-0 top-0 left-0 w-full h-full ${className} bg-black`}
    >
      {/*<img*/}
      {/*  src={mobileImage.url}*/}
      {/*  alt="Alex Yadgarov, Esq."*/}
      {/*  srcSet={`*/}
      {/*      ${mobileImage.url} 480w,*/}
      {/*      ${tabletImage.url} 768w,*/}
      {/*      ${desktopImage.url} 1280w*/}
      {/*`}*/}
      {/*  sizes="100vw"*/}
      {/*  className={clsx({*/}
      {/*    [imageClassName]: true,*/}
      {/*    "block object-cover object-right-top w-full h-full max-w-[1920px] mx-auto aspect-auto": true,*/}
      {/*  })}*/}
      {/*/>*/}
      <PrismicNextImage
        field={desktopImage}
        fallbackAlt=""
        priority={true}
        loading="eager"
        imgixParams={{ auto: "compress,format" }}
        className={`block object-cover object-right-top w-full h-full max-w-[1920px] mx-auto aspect-auto ${imageClassName}`}
      />
      {/*<PrismicNextImage*/}
      {/*  field={tabletImage}*/}
      {/*  fallbackAlt=""*/}
      {/*  priority={true}*/}
      {/*  loading="eager"*/}
      {/*  imgixParams={{*/}
      {/*    auto: "compress,format",*/}
      {/*  }}*/}
      {/*  className={`hidden md:block lg:hidden object-cover aspect-auto w-full h-full ${imageClassName}`}*/}
      {/*/>*/}
      {/*<PrismicNextImage*/}
      {/*  field={desktopImage}*/}
      {/*  fallbackAlt=""*/}
      {/*  priority={true}*/}
      {/*  loading="eager"*/}
      {/*  imgixParams={{*/}
      {/*    auto: "compress,format",*/}
      {/*  }}*/}
      {/*  className={`hidden lg:block object-cover aspect-auto w-full h-full ${imageClassName}`}*/}
      {/*/>*/}
      {horizontalGradient ? (
        <div className="absolute bg-gradient-to-l from-[rgba(0,0,0,0)] to-[rgba(0,0,0,1)] md:to-[rgba(0,0,0,0.8)] w-full h-full z-1 top-0 left-0"></div>
      ) : (
        <div className="absolute bg-gradient-to-b md:bg-gradient-to-l from-[rgba(0,0,0,0)] to-[rgba(0,0,0,1)] md:to-[rgba(0,0,0,0.8)] w-full h-full z-1 top-0 left-0"></div>
      )}
    </div>
  );
}
